import { useState, useCallback } from 'react';

export const useTermsOfServiceModal = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  const openTermsModal = useCallback(() => {
    setIsTermsOpen(true);
  }, []);

  const closeTermsModal = useCallback(() => {
    setIsTermsOpen(false);
  }, []);

  const openPrivacyModal = useCallback(() => {
    setIsPrivacyOpen(true);
  }, []);

  const closePrivacyModal = useCallback(() => {
    setIsPrivacyOpen(false);
  }, []);

  return {
    isTermsOpen,
    isPrivacyOpen,
    openTermsModal,
    closeTermsModal,
    openPrivacyModal,
    closePrivacyModal,
  };
};
